import moment from 'moment';

import { createSlice } from '@reduxjs/toolkit';
import { getHiddenDataPointsList } from '@pages/settings/helper';
import _ from 'lodash';
const initialState = {
  settings: {},
  hiddenDataPointsForAssets: {},
  loading: false,
  oldSettings: {},
  updatedSettings: {},
  isSettingUpdated: false,
  lastSync: null,
  lastSyncReminder: null,
  syncReminderFrequency: 0,
  appVersionNumber: 0,
  isAppUpdatable: false,
  isAppUpdating: false,
  isUpdatingComplete: false,
  isUpdateFailed: false,
  movingTasksAssetsReduxToIndexDBInprogress: false,
  movingTasksAssetsReduxToIndexDBCompleted: false,
  companySupportText: '',
  isChangingPSVVesselRelationship: false,
  snoozeTimeStartTime: null
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSnoozeTimeStartTime: (state, action) => {
      state.snoozeTimeStartTime = action.payload;
    },

    setInitialLoginSettings: (state, action) => {
      let settings = action.payload || {};

      let localStorageHaveOldSettings = !_.isEmpty(state.updatedSettings) ? true : false;

      state.settings = settings;

      if (!localStorageHaveOldSettings) {
        state.updatedSettings = {};

        state.isSettingUpdated = false;
        state.hiddenDataPointsForAssets = getHiddenDataPointsForAssets({
          newSetting: state.settings
        });
      }
      state.oldSettings = settings;
      state.lastSync = moment().format();
      state.lastSyncReminder = moment().format();
      state.syncReminderFrequency = 0;
      state.appVersionNumber = 0;

      if (localStorageHaveOldSettings) {
        let newSettings = {};
        for (let key of Object.keys(settings)) {
          if (state.updatedSettings[key]) {
            newSettings = {
              ...newSettings,
              [key]: state.updatedSettings[key]
            };
          } else {
            newSettings = {
              ...newSettings,
              [key]: settings[key]
            };
          }
        }
        state.settings = newSettings;
      }
    },

    setSettings: (state, action) => {
      let settings = action.payload || {};
      if (settings.newSettings) {
        state.settings = { ...state.settings, ...settings.newSettings };
        state.updatedSettings = { ...state.updatedSettings, ...settings.newSettings };
      } else {
        state.settings = settings;
        state.updatedSettings = {};
        state.oldSettings = settings;
        state.lastSync = moment().format();
        state.lastSyncReminder = moment().format();
        state.syncReminderFrequency = 0;
        state.appVersionNumber = 0;
      }
      state.isSettingUpdated = false;

      state.hiddenDataPointsForAssets = getHiddenDataPointsForAssets({
        newSetting: state.settings
      });
    },
    updateSettingsByName: (state, action) => {
      state.isSettingUpdated = true;
      const { name, value, searchingDataPoints = {} } = action.payload;

      state.hiddenDataPointsForAssets = {
        ...state.hiddenDataPointsForAssets,
        ...searchingDataPoints
      };

      state.settings[name] = value;
      state.updatedSettings[name] = value;
      if (state.oldSettings[name] == value) {
        delete state.updatedSettings[name];
      }
    },

    setLocalStorageOldSettings: (state, action) => {
      state.isSettingUpdated = true;
      const { updatedSettings, hiddenDataPointsForAssets } = action.payload;
      state.hiddenDataPointsForAssets = {
        ...hiddenDataPointsForAssets
      };
      state.updatedSettings = updatedSettings;
    },

    addOrUpdateNewAndExistingBookmark: (state) => {
      state.isSettingUpdated = true;
    },

    setTokenExpireModalTime: (state, action) => {
      state.tokenExpireModalTime = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLastSync: (state, action) => {
      state.lastSync = action.payload;
    },
    setLastSynReminder: (state, action) => {
      state.lastSyncReminder = action.payload;
    },
    setSyncReminderFrequency: (state, action) => {
      state.syncReminderFrequency = action.payload;
      // state.isSettingUpdated = false;
    },
    setAppVersionNumber: (state, action) => {
      state.appVersionNumber = action.payload;
    },

    setIsChangingPSVVesselRelationship: (state, action) => {
      state.isChangingPSVVesselRelationship = action.payload;
    },
    setAppUpdateStatus: (state, action) => {
      const {
        isAppUpdatable = false,
        isAppUpdating = false,
        isUpdatingComplete = false,
        isUpdateFailed = false,
        movingTasksAssetsReduxToIndexDBInprogress = false
      } = action.payload;
      state.isAppUpdatable = isAppUpdatable;
      state.isAppUpdating = isAppUpdating;
      state.isUpdatingComplete = isUpdatingComplete;
      state.isUpdateFailed = isUpdateFailed;
      state.movingTasksAssetsReduxToIndexDBInprogress = movingTasksAssetsReduxToIndexDBInprogress;
    },
    setAppUpdateStatusForWorkOrder: (state, action) => {
      const { movingTasksAssetsReduxToIndexDBCompleted } = action.payload;
      state.movingTasksAssetsReduxToIndexDBCompleted = movingTasksAssetsReduxToIndexDBCompleted;
    },
    setCompanySupportText: (state, action) => {
      state.companySupportText = action.payload;
    }
  }
});

const settingsReducer = settingsSlice.reducer;

export const settingsActions = settingsSlice.actions;
export default settingsReducer;

export const getHiddenDataPointsForAssets = ({ newSetting }) => {
  const hiddenAssetsName = [
    { key: 'site', fieldName: 'siteDisplayFields' },
    {
      key: 'equipment',
      fieldName: 'equipmentDisplayFields'
    },

    {
      key: 'structure',
      fieldName: 'structureDisplayFields'
    },
    {
      key: 'pipeline',
      fieldName: 'pipelineDisplayFields'
    },
    {
      key: 'inspection',
      fieldName: 'inspectionDisplayFields'
    },

    {
      key: 'workorder',
      fieldName: 'workorderDisplayFields'
    },

    {
      key: 'check',
      fieldName: 'checkDisplayFields'
    }
  ];

  let searchingDataPoints = {};
  for (let a of hiddenAssetsName) {
    let obj = newSetting[a.fieldName];

    const displayFields = obj;

    let searchingDataPointsForAssets = getHiddenDataPointsList({ name: a.key, displayFields });

    let b = {
      [`${a.key}`]: searchingDataPointsForAssets
    };

    searchingDataPoints = {
      ...searchingDataPoints,
      ...b
    };
  }

  return searchingDataPoints;
};
